import { render } from "./Upload_Data.vue?vue&type=template&id=970f36ec&scoped=true"
import script from "./Upload_Data.vue?vue&type=script&lang=js"
export * from "./Upload_Data.vue?vue&type=script&lang=js"

import "./Upload_Data.vue?vue&type=style&index=0&id=970f36ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970f36ec"]])

export default __exports__